<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="访客申请配置" subheading="" />
      <a @click="toModifyConfig" v-if="permissionCodes.indexOf('007001001') !== -1">修改</a>
    </div>
    <ul>
      <li>
        <b>拜访人是否精确匹配：</b>
        <span v-if="isMatchingPerson === '1'">是</span>
        <span v-else>否</span>
      </li>
      <li>
        <b>来访人身份证号是否必填：</b>
        <span v-if="idCardIsMust === '1'">是</span>
        <span v-else>否</span>
      </li>
      <li>
        <b>来访人人脸照片是否必填：</b>
        <span v-if="personPicIsMust === '1'">是</span>
        <span v-else>否</span>
      </li>
      <li>
        <b>是否需要审批：</b>
        <span v-if="approveIsMust === '1'">是</span>
        <span v-else>否</span>
      </li>
      <li>
        <b>访客权限：</b>
        <span v-if="openType === '1'">仅拥有被访人所在楼层权限</span>
        <span v-else-if="openType === '2'">拥有被访人所有权限</span>
        <span v-else>否</span>
      </li>
      <li style="display: flex;justify-content: flex-start;align-items: flex-start;">
        <b>访客登记二维码：</b>
        <div>
          <canvas class="qrcode" ref="visitorUrl" id="creatCode"></canvas>
          <el-select v-model="chargeSize" size="mini" style="width: 140px;margin: 0 auto;display: block;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { errorHandler } from "../../../utils/errorHandler";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { api } from "../../api/Visitor";
import TextTitle from "../../../components/Text/TextTitle";
import { bus } from "../../../utils/bus";
import QrCodeWithLogo from "qr-code-with-logo";

export default {
  components: {
    TextTitle,
    Breadcrumb
  },
  name: "visitor-config",
  data() {
    return {
      permissionCodes: "",
      config: {
        breadcrumb: [
          {
            value: "智慧访客",
            name: "visitor-device-manage"
          },
          {
            value: "访客申请配置"
          }
        ]
      },
      code: "",
      isMatchingPerson: "",
      idCardIsMust: "",
      personPicIsMust: "",
      approveIsMust: "",
      openType: '',

      options: [
        {
          value: 300,
          label: "300*300"
        },
        {
          value: 500,
          label: "500*500"
        },
        {
          value: 1000,
          label: "1000*1000"
        }
      ],
      chargeSize: 300
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getVisitorConfig();
    this.getCodes();
  },
  methods: {
    toModifyConfig() {
      this.$router.push({
        name: "visitor-config-modify"
      });
    },
    getVisitorConfig() {
      this.$axios
        .post(api.getVisitorConfig, {})
        .then(res => {
          let data = res.data.data;
          if (data) {
            this.isMatchingPerson = data.isMatchingPerson;
            this.idCardIsMust = data.idCardIsMust;
            this.personPicIsMust = data.personPicIsMust;
            this.approveIsMust = data.approveIsMust;
            this.openType = data.openType
          }
        })
        .catch(errorHandler("获取配置数据失败"));
    },

    getCodes() {
      setTimeout(() => {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById("creatCode"),
          content: `https://yq.damaiiot.com/yq/smallProgram/register/?yqCode=${
            bus.global.yqCode
          }&register=true`,
          width: this.chargeSize
        }).catch();
      }, 100);
    }
  },
  watch: {
    chargeSize(Val) {
      this.getCodes();
    }
  }
};
</script>

<style scoped>
.main_right {
  text-align: left;
}

.flexBox {
  display: flex;
  justify-content: space-between;
}

.flexBox a {
  line-height: 58px;
  margin-right: 40px;
  cursor: pointer;
  color: #00a0e6;
}
.flexBox a:hover {
  color: #06b3ff;
}

.main_right ul {
  width: 80%;
  margin: 10px auto 0;
  line-height: 40px;
}

.main_right ul li {
  width: 100%;
  padding: 4px 0;
  margin-bottom: 10px;
}
.main_right ul li b {
  color: #48576a;
  font-weight: 400;
  display: inline-block;
  width: 180px;
  text-align: right;
  margin-right: 15px;
}

.main_right ul li span {
  color: #333;
}

#creatCode {
  display: block;
  width: 140px !important;
  height: 140px !important;
  margin: 0 auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/VisitorConfig/VisitorConfig.vue